import { render, staticRenderFns } from "./ComboboxAnswer.vue?vue&type=template&id=567a6ae0&scoped=true"
import script from "./ComboboxAnswer.vue?vue&type=script&lang=js"
export * from "./ComboboxAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a6ae0",
  null
  
)

export default component.exports